<script>
export default {
  data() {
    return {
      isLoading: false,
      answers: {},
    };
  },
  computed: {
    authCustomer() {
      return this.$store.getters['auth/customer'];
    },
    storeData() {
      return this.$store.state.store.data;
    },
    options() {
      return this.storeData && this.storeData.custom_fields_options;
    },
    fields() {
      if (!this.options || !this.options.enabled) return [];
      return this.options.fields || [];
    },
  },
  created() {
    this.answers = this.buildInitialAnswers();
  },
  watch: {
    fields() {
      this.answers = this.buildInitialAnswers();
    },
  },
  methods: {
    buildInitialAnswers() {
      const existing = ((this.authCustomer && this.authCustomer.custom_fields_data) || [])
        .reduce((acc, a) => {
          acc[a.name] = a.value;
          return acc;
        }, {});

      return this.fields.reduce((acc, field) => {
        if (Object.prototype.hasOwnProperty.call(existing, field.name)) {
          acc[field.name] = field.type === 'checkbox'
            ? existing[field.name] === 'true' || existing[field.name] === true
            : existing[field.name];
        } else {
          acc[field.name] = field.type === 'checkbox' ? false : '';
        }
        return acc;
      }, {});
    },
    formatAnswer(field, raw) {
      if (field.type === 'checkbox') {
        return { value: raw ? 'true' : 'false', label: raw ? this.$t('yes') : this.$t('no') };
      }
      if (field.type === 'select') {
        return { value: raw, label: String(raw ?? '').slice(0, 255) };
      }
      return { value: String(raw ?? ''), label: String(raw ?? '').slice(0, 255) };
    },
    isAnswerEmpty(field, raw) {
      if (field.type === 'checkbox') return false;
      return raw === '' || raw === null || raw === undefined;
    },
    handle() {
      const payload = [];

      for (const field of this.fields) {
        const raw = this.answers[field.name];
        if (field.required && this.isAnswerEmpty(field, raw)) {
          this.$showMessage.error(this.$t('field_required', { label: field.label }));
          return;
        }
        if (!this.isAnswerEmpty(field, raw)) {
          payload.push({
            name: field.name,
            answer: this.formatAnswer(field, raw),
          });
        }
      }

      this.isLoading = true;
      this.$store.dispatch('auth/submitCustomFields', { answers: payload })
        .then(() => this.$showMessage.success())
        .catch(() => this.$showMessage.error(this.$t('save_error')))
        .finally(() => { this.isLoading = false; });
    },
  },
  i18n: {
    messages: {
      fr: {
        title: 'Mes informations',
        intro: 'Les informations demandées par votre formateur.',
        select_placeholder: '-- Sélectionner --',
        save: 'Enregistrer',
        field_required: 'Le champ "{label}" est obligatoire.',
        save_error: "Impossible d'enregistrer vos réponses, veuillez réessayer.",
        yes: 'Oui',
        no: 'Non',
      },
      en: {
        title: 'My information',
        intro: 'Information requested by your trainer.',
        select_placeholder: '-- Select --',
        save: 'Save',
        field_required: 'The field "{label}" is required.',
        save_error: 'Unable to save your answers, please try again.',
        yes: 'Yes',
        no: 'No',
      },
    },
  },
};
</script>

<template>
  <form v-if="fields.length" class="box" @submit.prevent="handle">
    <h2 class="title is-5">
      {{ $t('title') }}
    </h2>
    <p class="mb-4">
      {{ $t('intro') }}
    </p>

    <b-field
      v-for="field in fields"
      :key="field.name"
    >
      <template v-if="field.type !== 'checkbox'" #label>
        {{ field.label }}
        <span v-if="field.required" class="has-text-danger">*</span>
      </template>

      <b-input
        v-if="field.type === 'text'"
        v-model="answers[field.name]"
        :required="field.required"
        expanded
      />
      <b-input
        v-else-if="field.type === 'textarea'"
        v-model="answers[field.name]"
        type="textarea"
        maxlength="1000"
        :required="field.required"
        expanded
      />
      <b-select
        v-else-if="field.type === 'select'"
        v-model="answers[field.name]"
        :required="field.required"
        expanded
      >
        <option value="" disabled>
          {{ $t('select_placeholder') }}
        </option>
        <option v-for="opt in field.options || []" :key="opt" :value="opt">
          {{ opt }}
        </option>
      </b-select>
      <b-checkbox
        v-else-if="field.type === 'checkbox'"
        v-model="answers[field.name]"
        type="is-custom"
      >
        {{ field.label }}
        <span v-if="field.required" class="has-text-danger">*</span>
      </b-checkbox>
    </b-field>

    <div class="has-text-right mt-4">
      <b-button
        type="is-primary is-custom"
        native-type="submit"
        :loading="isLoading"
      >
        {{ $t('save') }}
      </b-button>
    </div>
  </form>
</template>
